document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-obfuscated-email]').forEach(function (el) {
    var email;
    try {
      email = atob(el.getAttribute('data-obfuscated-email'));
    } catch (error) {
      return;
    }

    if (el.tagName === 'A') {
      el.href = 'mailto:' + email;
    }

    var textTarget = el.querySelector('[data-obfuscated-email-text]');
    if (textTarget) {
      textTarget.textContent = email;
    }
  });
});
